import classNames from "classnames";
import { createContext, memo } from "react";
import { Flex } from "../../flex";
import { Text } from "../../text";
import * as darkModeCss from "../../theme/component-colors-dark.module.css";
import * as navigationCss from "../redo-navigation.module.css";

export interface SecondaryNavigationData {
  id: string;
  name: string;
  NavContent: React.FC<{ pathRoot: string }>;
}

export const SecondaryNavigationContext = createContext<
  SecondaryNavigationData | undefined
>(undefined);

/**
 * Provides the section ID (e.g., "support", "orders") to secondary nav items
 * so they can include it in analytics events.
 */
export const NavSectionIdContext = createContext<string>("");

export const RedoSecondaryNav = memo(function RedoSecondaryNav({
  data,
  pathRoot,
}: {
  data: SecondaryNavigationData | undefined;
  pathRoot: string;
}) {
  if (!data) {
    return null;
  }
  const { name, NavContent } = data;

  return (
    <Flex
      bgColor="primary"
      className={classNames(darkModeCss.darkMode, navigationCss.secondaryNav)}
      data-arbiter="RedoSecondaryNav"
      dir="column"
      grow={1}
      px="md"
      py="md"
    >
      {name && (
        <Flex pb="lg" pt="xl" px="md">
          <Text fontSize="sm" fontWeight="regular" textColor="secondary">
            {name}
          </Text>
        </Flex>
      )}
      <NavSectionIdContext.Provider value={data.id}>
        {/* grow={1} lets nav content fill the rail's height so footer-style
            children (e.g. CRO-1387 sidebar promo) can pin to the bottom via
            `mt="auto"`. Items naturally stack at the top, leaving empty
            space below — visually unchanged for navs without a footer. */}
        <Flex dir="column" gap="xs" grow={1}>
          <NavContent pathRoot={pathRoot} />
        </Flex>
      </NavSectionIdContext.Provider>
    </Flex>
  );
});
